import React, { useEffect, useState } from "react";
import { notification } from 'antd';
import dayjs from 'dayjs';
import { DescriptionText, FlexContainer, H1Text, H2Text, LeftBackButtonText, Spinner } from "../../design";
import TransactionModal from "../../components/modal/transaction";
import SuccessModal from "../../components/modal/success";
import { addZohoPaymentChargeById, getZohoPaymentLinkById, BASE_URLS, getZohoPaymentLinkByAuth, cancelZohoPaymentLink, getHealthCheck } from "../../api";
import { MESSAGES, TabNames, INDIAN_STATES, SWIREPAY_URL, LPG_CUSTOMER } from "../../appconstants";
import BaseSplitPage from "../../components/splitpage";
import Header from "./smallscreen/header";
import currencyFormatter from "../../utils/currencyformatter";
import CardPayment from "../../components/cardpayment/CardPayment";
import Support from "../../components/support";
import getMenuTabs from "../../utils/getMenuTabs";
import getUniquePaymentTypes from "../../utils/getUniquePaymentTypes";
import UpiPayment from "../../components/upipayment/UpiPayment";
import AchPayment from "../../components/achPaymentWithPlaid";
import BankPayment from "../../components/bankpayment/BankPayment";
import GooglePay from "../../components/googlePay/GooglePay";
import PaymentMethodTabs from "../../components/paymentmethodtabs";
import AlertModal from "../../components/modal/alert";
import WARNING_ICON from "../../assets/imgs/exclamation_warning.svg"
import SUCCESS_ICON from "../../assets/imgs/success.svg";
import UPIIMAGE from "../../assets/imgs/upiNotification.svg";

type Props = {
    history: {
        push: Function,
    },
}

const ZohoPaymentLink = (props: Props) => {

    const { match: { params: { zohoPaymentId } }, location: { pathname, search } } = props;
    const [isTransactionModalOpen, setTransactionModalOpen] = useState(false);
    const [isTransactionSuccessModalOpen, setTransactionSuccessModalOpen] = useState(false);
    const [payment, setPayment] = useState(null);
    const [errorMessage, setErrorMessage] = useState();
    const [isShowSpinner, setShowSpinner] = useState(false);
    const [submitBtnText, setSubmitBtnText] = useState(null);
    const [supportedPaymentTypes, setSupportedPaymentTypes] = useState(null);
    const [amount, setAmount] = useState(null);
    const [countryAlpha2, setCountryAlpha2] = useState(null);
    const [selectedTab, setSelectedTab] = useState(parseInt(localStorage.getItem(`${zohoPaymentId}-tap-index`) || 0));
    const [tabName, setTabName] = useState('');
    const [upiDownTime, setUpiDownTime] = useState(false);
    const accountGid = [
      'account-cdfe7eecff324778a88a2727177a1c8f'
    ];
    const [plaidPublicToken, setPlaidPublicToken] = useState(() => localStorage.getItem(`plaidPublicToken-${zohoPaymentId}`) || undefined);
    const defaultAlertConfig = {
        showIcon:false, isOpen:false, hideBtn: true,
        cancel: null, header:null, body: null,
        submitBtnText: null, cancelBtnText: null, showCancelBtn: false,
        showSubmitBtn: false, submit: null, icon: null
    };

    const [alertConfig, setAlertConfig] = useState(defaultAlertConfig);

    const [ipAddress, setIpAddress] = useState('');

const getData = async () => {
    const response = await fetch('https://api.ipify.org/?format=json');
    const data = await response.json();
    setIpAddress(data.ip);
  }

  useEffect(() => {
    getData();
  }, []);

    useEffect(() => {
        if (search) {
            getZohoPaymentDataWithSearchValue();
        } else {
            getPaymentLinkDataWithoutSearchValue();
        }
    }, [zohoPaymentId, search]);

    useEffect(() => {
        if (payment && payment.currencyCode && payment.amount) {
            setSubmitBtnText(`PAY ${currencyFormatter(payment.amount, payment.currencyCode)}`)
        }
        setSupportedPaymentTypes(payment && getUniquePaymentTypes(payment.supportedPaymentTypes));
    }, [payment]);

    useEffect(() => {
        setTabName(supportedPaymentTypes && supportedPaymentTypes[selectedTab]);
    }, [selectedTab, supportedPaymentTypes]);

    useEffect(() => {
        if (payment && payment.currencyCode !== 'INR') { setSelectedTab(0) }
    }, [selectedTab,]);

    const findStateByName = (name) => {
        const state = INDIAN_STATES.find(value => value.name === name);
        return state.code;
    };

    const getZohoPaymentDataWithSearchValue = async () => {
        const params = new URLSearchParams(search);
        const paymentSessionId = params.get('ps');
        if (!paymentSessionId) {
            props.history.push(`${pathname}/error`);
            return;
          }
        setShowSpinner(true);
        try {
            const value = await getZohoPaymentLinkByAuth(zohoPaymentId, paymentSessionId);
            if (value) {
                const { redirectUrl } = value;
                setTransactionModalOpen(false);
                setTransactionSuccessModalOpen(true);
                setTimeout(function () {
                    window.location = redirectUrl;
                }, 5000);
            }
        } catch (reason) {
            try {
                const value = await getZohoPaymentLinkById(zohoPaymentId, null);
                if (value) { 
                    const { amount } = value;
                    value.name = `${value.firstName ? value.firstName : ''} ${value.lastName ? value.lastName : ''}`;
                    setPayment(value);
                    setAmount(amount);
                 }
            } catch (e) {
                props.history.push(`${pathname}/error`);
            }
            error(reason);
        } finally {
            setShowSpinner(false);
        }
    };

    const error = reason => {
        setErrorMessage(null);
        const { data: { message }, status } = reason;
        setErrorMessage(message);
        if (status === 500) {
            setErrorMessage(MESSAGES.SETUP_INTENT.ERROR);
        }
        resetAlertConfig();
        setTransactionModalOpen(false);
        const errorEl = document.getElementById("error");
        if (null !== errorEl) { errorEl.scrollIntoView(); }
    };

    const getPaymentLinkDataWithoutSearchValue = async () => {
        setShowSpinner(true);
        try {
            const value = await getZohoPaymentLinkById(zohoPaymentId, null);
            if (value) {
                // if (value.account.integratedMerchant && LPG_CUSTOMER.includes(atob(value.account.integratedMerchant))) {
                //     const val = await getHealthCheck();
                //     if (val && val.status !== 'ACTIVE') {
                //         setUpiDownTime(true);
                //         notification.open({
                //             message: '',
                //             description: <img src={UPIIMAGE} alt="" />,
                //           });
                //     }
                //   }
                const { amount } = value;
                value.name = `${value.firstName ? value.firstName : ''} ${value.lastName ? value.lastName : ''}`;          
                setPayment(value);
                setAmount(amount);
            }
        } catch (e) {
            props.history.push(`${pathname}/error`);
        } finally {
            setShowSpinner(false)
        }
    };

    const chargeByUpi = async (data) => {
        const { paymentMethod, customer } = data;
        customer.billingAddress = payment.billingAddress;
        const paymentData = {
            paymentMethod : paymentMethod,
            customer: customer,
        };
        await chargeById(paymentData);
    };

    const chargeByAch = async (data) => {
        const { paymentMethod } = data;
        const paymentDetails = { 
            paymentMethod,
            amount,
        }; 
        await chargeById(paymentDetails);
    };

    const chargeByCard = async (data) => {
        const { paymentMethod, customer } = data;
        const userAgent = {
            acceptHeaders: "Accept: text/html, application/xhtml+xml, application/xml;q=0.9, image/webp, */*;q=0.8", 
            ip: ipAddress,
            language: window.navigator.language, 
            colorDepth: window.screen.colorDepth,
            screenHeight: window.screen.height, 
            screenWidth: window.screen.width,
            timeZone: new Date().getTimezoneOffset(), 
            browserUserAgent: window.navigator.userAgent
           };
           paymentMethod.userAgent = userAgent;
        const payment = {
            paymentMethod : paymentMethod,
            customer: customer,
        };
        await chargeById(payment);
    };

    const chargeByBank = async (data) => {
        const { customerGid, fundingSourceId } = data;
        const paymentMethod = {
            bank: {
                referenceId: fundingSourceId,
            },
            customerGid,
            type: "ACH"
        }
        await chargeById({ paymentMethodDetails: paymentMethod });
    };

    const chargeByGooglePay = async (data) => {
        const paymentMethod = {
            type: "WALLET",
            subType: "GOOGLE_PAY_US",
            googlePayUS: {
                apiVersionMinor: data.apiVersionMinor,
                apiVersion: data.apiVersion,
                paymentMethodDescription: data.paymentMethodData.description,
                paymentMethodTokenizationDataType: data.paymentMethodData.tokenizationData.type,
                paymentMethodTokenizationDataToken: data.paymentMethodData.tokenizationData.token,
                paymentMethodType: data.paymentMethodData.type,
                paymentMethodInfo: data.paymentMethodData.info
            },
        };
        await chargeById({ paymentMethod: paymentMethod});
    };

    const chargeById = async (data) => {
        setTransactionModalOpen(true);
        try {
            const value = await addZohoPaymentChargeById(zohoPaymentId, data);
            if (value) {
                const { nextActionUrl, redirectUrl } = value;
                if (nextActionUrl) {
                    window.location = nextActionUrl;
                    return;
                }
                setTransactionModalOpen(false);
                setTransactionSuccessModalOpen(true);
                setTimeout(function () {
                    window.location = redirectUrl;
                }, 5000);
                if (zohoPaymentId) { localStorage.removeItem(`${zohoPaymentId}-tap-index`) }
            }
        } catch (e) {
            error(e.response);
        }
    };

    const declinePaymentLink = () => {
        setAlertConfig({...defaultAlertConfig,
            showIcon: true, isOpen: true, hideBtn: true,
            header: `Please Wait!. Your payment decline is being processed`, body: "You will be redirected when the decline is successful.",
        });
        if(zohoPaymentId) {
            cancelZohoPaymentLink(zohoPaymentId).then(value => {
                if (value) {
                    const { cancelUrl } = value;
                    setAlertConfig({...defaultAlertConfig,
                        showIcon:true, isOpen:true, hideBtn: true,
                        header: "Payment was cancelled", body: "Please use any other payment method or try again later. You will be redirected automatically.",
                        icon: SUCCESS_ICON
                    });
                    setTimeout(function () {
                        const redirectUrl = cancelUrl || SWIREPAY_URL;
                        window.location = redirectUrl;
                    }, 5000);
                }
            }).catch(reason => error(reason));
        }
    };

    const cancelAlertOpen = () => {
        setAlertConfig({
            showIcon:true, isOpen:true, hideBtn: false,
            cancel: resetAlertConfig, header: "Are you sure!", body: "Do you want to decline the payment",
            submitBtnText: "Yes, decline it!", cancelBtnText: "Cancel", showCancelBtn: true,
            showSubmitBtn: true, submit: declinePaymentLink, icon: WARNING_ICON
        });
    };

    const resetAlertConfig = () => {
        setAlertConfig(defaultAlertConfig)
      };

    const tabPanels = supportedPaymentTypes ? supportedPaymentTypes.reduce(function (panel, name) {
        let children;
        if (name === TabNames.ACH_LEGACY) {
            children = <AchPayment
                showCancelBtn={true}
                cancel={cancelAlertOpen}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByAch}
                preFillCustomer={payment}
                customerDisabled={true}
                headerText={accountGid.includes(payment?.account?.gid) ? "Pay With BANK" : "Pay With ACH"}
                buttonText={submitBtnText}
                customerValidation={true}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                alpha2={payment && payment.currencyCode && countryAlpha2}
                plaidPublicToken={plaidPublicToken}
                setPlaidPublicToken={setPlaidPublicToken}
                accountGid={payment?.account?.gid}
                paymentLinkId={zohoPaymentId}
                isTest={payment?.account?.portal?.test}
                enableConsentCheckbox={true} 
                accountName={payment?.account?.name}
                paymentDate={dayjs().format('MMMM D, YYYY')}
                finalPayAmount={payment ? `${currencyFormatter(amount, payment.currencyCode)}` : null}
            />
        } else if (name === TabNames.CARD) {
            children = <CardPayment
                showCancelBtn={true}
                cancel={cancelAlertOpen}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByCard}
                preFillCustomer={payment}
                headerText={"Pay With Card"}
                buttonText={submitBtnText}
                customerValidation={true}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                alpha2={payment && payment.currencyCode && countryAlpha2}
                payments={payment}
            />
        } else if (name === TabNames.UPI) {
            children = <UpiPayment
                showCancelBtn={true}
                cancel={cancelAlertOpen}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByUpi}
                preFillCustomer={payment}
                headerText={"Pay With UPI"}
                buttonText={submitBtnText}
                customerValidation={true}
                alpha2={payment && payment.currencyCode && countryAlpha2}
            />
        } else if (name === TabNames.ACH) {
            children = <BankPayment
                showCancelBtn={true}
                cancel={cancelAlertOpen}
                errorMsg={errorMessage}
                errorHeader={null}
                customerDisabled={false}
                submit={chargeByBank}
                preFillCustomer={payment}
                headerText={"Pay With Bank Transfer"}
                buttonText={submitBtnText}
                zohoPaymentId={zohoPaymentId}
                iavUrl={`${BASE_URLS.PAYMENT_LINK}/${zohoPaymentId}`}
                customerValidation={true}
                alpha2={payment && payment.currencyCode && countryAlpha2}
            />
        } else if (name === TabNames.GOOGLE_PAY_US) {
            children= <GooglePay
              headerText={"PAY WITH GOOGLE PAY"}
              payment={payment}
              chargeByGooglePay={chargeByGooglePay}
              errorMsg={errorMessage}
              errorHeader={null}
            />
        } else if (name === TabNames.WALLET) {
            children= <GooglePay
              headerText={"PAY WITH GOOGLE PAY"}
              payment={payment}
              chargeByGooglePay={chargeByGooglePay}
              errorMsg={errorMessage}
              errorHeader={null}
            />
        } else {
            children = <DescriptionText>Processing payment. Please wait...</DescriptionText>
        }
        panel.push({ children });
        return panel;
    }, []) : [
        {
            children: <CardPayment
                showCancelBtn={true}
                cancel={cancelAlertOpen}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByCard}
                preFillCustomer={payment}
                headerText={"Pay With Card"}
                buttonText={submitBtnText}
                customerValidation={true}
                alpha2={payment && payment.currencyCode && countryAlpha2}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                amountReadOnly={payment && payment.zohobooksinstance && !payment.zohobooksinstance.supportPartialPayment}
                payments={payment}
            />
        }
    ];

    return (
        <BaseSplitPage
        errorHeader={null}
        errorMsg={errorMessage}
        left={
            <>
                <FlexContainer
                    flexDirection="column"
                    position="relative"
                    display="block"
                    height="100%"
                >
                    <div>
                        <H1Text>
                            Payment Checkout
                      </H1Text>
                        <H2Text>
                            Payment For
                      </H2Text>
                        <DescriptionText>
                            {payment && payment.invoiceNumber}
                        </DescriptionText>
                        <H2Text>
                            Amount Payable
                      </H2Text>
                        <DescriptionText fontSize="24px">
                            {payment ? `${currencyFormatter(amount, payment.currencyCode)}` : null}
                        </DescriptionText>
                    </div>
                    <div style={{ position: "sticky", top: "85%" }}>
                        <Support email={payment && payment.support && payment.support.email}
                            phone={payment && payment.support && payment.support.phone} />
                    </div>
                </FlexContainer>
            </>
        } right={
            <>
                <Header 
                    payment={payment} 
                    cancelUrlLink={null}
                />
                <PaymentMethodTabs
                    name={zohoPaymentId}
                    paymentTypes={(payment && payment.currencyCode && countryAlpha2)}
                    tabs={getMenuTabs(supportedPaymentTypes)}
                    tabPanels={tabPanels}
                    defaultSelectedTab={selectedTab || 0}
                    onSelect={data => setSelectedTab(data)}
                    tabName={tabName}
                    upiDown={upiDownTime}
                    accountGid={payment?.account?.gid}
                />
                <TransactionModal body={null} header={null} isOpen={isTransactionModalOpen} />
                <SuccessModal isOpen={isTransactionSuccessModalOpen} />
                <AlertModal
                  showIcon={alertConfig.showIcon}
                  isOpen={alertConfig.isOpen}
                  hideBtn={alertConfig.hideBtn}
                  cancel={alertConfig.cancel}
                  header={alertConfig.header}
                  body={alertConfig.body}
                  submitBtnText={alertConfig.submitBtnText}
                  cancelBtnText={alertConfig.cancelBtnText}
                  showCancelBtn={alertConfig.showCancelBtn}
                  showSubmitBtn={alertConfig.showSubmitBtn} submit={alertConfig.submit} icon={alertConfig.icon}/>
                <Spinner isOpen={isShowSpinner} />
            </>
        } />
    )
};

export default ZohoPaymentLink;
